var _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPisaBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 400,
    viewBox: "0 0 800 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 220,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 160,
    fill: "#ffffff",
    letterSpacing: 5
  }, "\n    pisa\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 250,
    fontFamily: "Brush Script MT, cursive",
    fontSize: 90,
    fill: "#c49a6c",
    transform: "rotate(-10 470 250)"
  }, "\n    Bar\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisaBar);
export default __webpack_public_path__ + "static/media/pisaBar.b2ba8e70643d90a4bf514d2388e9e148.svg";
export { ForwardRef as ReactComponent };